import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class MiintoSizeMapApiClient extends AdvancedApiClient {

    static entityType = "MiintoSizeMap"

    constructor(token, sizeId, id) {
        super();

        this.setEntityType(MiintoSizeMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/size/{sid}/miinto-map/{id}")
                .setRouteParam("sid", sizeId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/size/{sid}/miinto-map")
                .setRouteParam("sid", sizeId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}